import React, { useLayoutEffect } from "react";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { useNavigation } from "@react-navigation/native";
import TabStackNavigator from "./TabStackNavigator";
import ChronologyScreen from "../screens/ChronologyScreen";
import CustomDrawer from "../components/CustomDrawer";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";

const DrawerStack = createDrawerNavigator();

const DrawerStackNavigator = () => {
	const navigation = useNavigation();
	useLayoutEffect(() => {
		navigation.setOptions({
			headerShown: false,
		});
	}, []);

	return (
		<DrawerStack.Navigator
			useLegacyImplementation
			drawerContent={(props) => <CustomDrawer {...props} />}
			screenOptions={{
				headerShown: false,
				// drawerPosition: "right",
				drawerActiveBackgroundColor: "#1E272C",
				drawerActiveTintColor: "white",
				drawerInactiveTintColor: "white",
				headerBackgroundContainerStyle: { backgroundColor: "#1E272C" },
			}}
			// backBehavior="history"
			// screenOptions={{
			// 	headerShown: true,
			// 	headerLeft: CustomHeader,
			// 	headerLeftContainerStyle: {
			// 		paddingLeft: 16,
			// 		justifyContent: "center",
			// 	},
			// 	headerTitleContainerStyle: {
			// 		alignItems: "center",
			// 		justifyContent: "center",
			// 	},
			// 	tabBarActiveTintColor: "white",
			// 	tabBarInactiveTintColor: "#2A373E",
			// 	tabBarStyle: {
			// 		backgroundColor: "#1E272C",
			// 	},
			// }}
		>
			<DrawerStack.Screen
				name="HomeDrawer"
				component={TabStackNavigator}
				options={{
					drawerLabel: "Home page",
					drawerIcon: ({ color }) => (
						<MaterialCommunityIcons
							name="home"
							color={color}
							size={26}
						/>
					),
				}}
			/>
			{/* <DrawerStack.Screen
				name="ChronoDrawer"
				component={ChronologyScreen}
				options={{
					drawerLabel: "Cronologia",
					drawerIcon: ({ color }) => (
						<MaterialCommunityIcons
							name="history"
							color={color}
							size={26}
						/>
					),
				}}
			/> */}
		</DrawerStack.Navigator>
	);
};

export default DrawerStackNavigator;
